<template>
  <div class="page page-accessibility">
    <img class="page-banner" src="../../assets/banners/accessibility.jpg">
    <div class="page-header">
        <h2><WFTranslate k="page-accessibility">Accessibility at Helsinki Central Railway Station</WFTranslate></h2>
        <WFTranslate k="page-accessibility-desciption"></WFTranslate>
    </div>
    <div class="page-description" v-if="language == 'en'">
        <h3>Assistance service</h3>
        <div>
            The assistance point is located by the platform no 11, under the glass roof of the station’s central platforms. The point is accessible from the Station Hall, Eliel Square, and the taxi stand in Asema-aukio Square. To book assistance service, call VR customer service for accessible travel at 0800 188 822 (free of charge, service hours Mon–Fri 05:00–22:00, Sat–Sun 07:00–22:00), no later than 36 hours before departure.
        </div>
        <div>
            <button class="btn btn-border btn-lg" @click="showRoute('poi', 'assist')">
                <WFIcon name="path"/><WFTranslate k="show_path">Show route</WFTranslate>
            </button>
        </div>
        <div>
            <h3>Platform area and station’s interior</h3>
        </div>
        <div>
            The accessible route to the railway platform is via the archway/corridor of Eliel Square. The accessible entrance is indicated on the information boards of the station. From there and through the automatic door you can also enter to VR’s service point, the station, and the post hall.
        </div>
        <div>
            <h3>Toilets</h3>
        </div>
        <div>
            The accessible toilet is located in floor 0. Accessible entry to the toilet facilities is provided via the elevator located opposite the VR service point.
        </div>
        <div>
            <button class="btn btn-border btn-lg" @click="showRoute('group', 'toilets')">
                <WFIcon name="path"></WFIcon><WFTranslate k="show_path">Show route</WFTranslate>
            </button>
        </div>
        <div>
            <h3>Metro</h3>
        </div>
        <div>
            The accessible route to the metro is by elevator, via a separate metro entrance located in Station Square.
        </div>
    </div>
    <div class="page-description" v-if="language == 'fi'">
        <h3>Avustamispalvelu</h3>
        <div>
            Avustamispiste sijaitsee aseman laiturikatoksen alla, laiturin nro 11 vieressä. Pisteelle pääsee kulkemaan esteettä asemahallista, Elielinaukiolta ja Asema-aukion taksiasemalta. Varaa avustamispalvelu puhelimitse esteettömän matkustuksen palvelunumerosta 0800 188 822 (maksuton, avoinna ma-pe 05:00–22:00, la–su 07:00–22:00), viimeistään 36 tuntia ennen matkalle lähtöä.
        </div>
        <div>
            <button class="btn btn-border btn-lg" @click="showRoute('poi', 'assist')">
                <WFIcon name="path"></WFIcon><WFTranslate k="show_path">Show route</WFTranslate>
            </button>
        </div>
        <div>
            <h3>Laiturialue ja sisätilat</h3>
        </div>
        <div>
            Esteetön kulkureitti laiturialueille kulkee Elielinaukion porttikongin/käytävän kautta, ja se on merkitty aseman opasteissa. Täältä ja automaattiovien kautta pääsee myös VR:n palvelupisteelle sekä aseman sisätiloihin postihalliin.
        </div>
        <div>
            <h3>WC</h3>
        </div>
        <div>
            Inva-WC sijaitsee aseman 0. kerroksessa. Esteetön kulku WC-tiloihin tapahtuu VR-palvelupisteen vastapäätä olevalla hissillä.
        </div>
        <div>
            <button class="btn btn-border btn-lg" @click="showRoute('group', 'toilets')">
                <WFIcon name="path"></WFIcon><WFTranslate k="show_path">Show route</WFTranslate>
            </button>
        </div>
        <div>
            <h3>Metro</h3>
        </div>
        <div>
            Esteetön kulkureitti metrolle tapahtuu ulkokautta hissillä Asema-aukion puolelta, erillisen metrosisäänkäynnin kautta.
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFTranslate } from '@3dwayfinder/wayfinder-vue-components'

export default {
    components: {
        WFTranslate,
    },
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    watch: {
        page () {
            console.log('page', this.page)
        }
    },
    mounted () {
        console.log('page2', this.page)
    },
    computed: {
        ...mapState('wf', ['language']),
    },
    methods: {
        showRoute (type, groupName) {
            this.$emit("showRoute", type, groupName);
        },
        viewOnMap (type,groupName) {
            this.$emit("viewOnMap", type, groupName);
        }
    }
}
</script>

<style lang="less" scoped>
    .page-accessibility {
        h3 {
            font-weight: 600;
        }

        .page-header {
            flex-direction: column;
        }

        .icon-phone {
            height: 2.2rem;
        }
    }
    .btn {
        margin-right: 1rem;
    }

    .btn-active .icon {
        --icon_color: white;
    }
</style>